// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"e74fa72b","288":"f627bc86","453":"694a9c13"}[chunkId] + ".chunk.js";
};